module.exports = __webpack_public_path__ + "img/114.a48a8d64.jpg";